// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import {
    handleActions,
} from 'redux-actions';

import deviceInfoReducer, { GET_CLAIM_DETAILS_DATA_SUCCESS } from './deviceInfo';
import eligibilityReducer from './eligibility';
import warrantyReducer from './warranty';
import claimOrderReducer from './claimOrder';
import { SHOW_ORDER_UPDATE_ALERT, HIDE_ORDER_UPDATE_ALERT } from './actions';

import {
    GET_REGISTRATION_SUCCESS,
} from './../../store/orderCreation';

import {
    GET_WARRANTY_INFO_DATA_SUCCESS,
} from './../../store/deviceInfo/warranty';

import {
    GET_SERVICE_REQUEST_DATA_SUCCESS
} from './../../store/deviceInfo/claimOrder';

import { GET_SHIPPING_LABEL_SUCCESS, RESET_DEVICE_DATA, GET_RECONCILE_USERS_SUCCESS,PUT_RECONCILE_SHIPPING_LABEL_SUCCESS,PUT_RECONCILE_SHIPPING_LABEL_FAILURE } from './../../store/deviceInfo';
import { GET_DEVICE_ELIGIBILITY_DATA_SUCCESS } from './../../store/deviceInfo/eligibility';

import { GET_DEVICE_INFO_DATA_SUCCESS } from './../../store/deviceInfo/deviceInfo';

import INITIAL_DEVICE_STATE from './initialState';

export type ServiceRequestDataType = Readonly<typeof INITIAL_DEVICE_STATE>;

export default handleActions(
    {
        [GET_DEVICE_ELIGIBILITY_DATA_SUCCESS]: (state, action) => ({
            ...state,
            ...eligibilityReducer(state.eligibilityOptions, action),
        }),

        [GET_DEVICE_INFO_DATA_SUCCESS]: (state, action) => ({
            ...state,
            ...deviceInfoReducer(state, action),
        }),

        [GET_SHIPPING_LABEL_SUCCESS]: (state: any, action) => ({
            ...state,
            shippingLabel: { ...action.payload },
        }),

        [GET_REGISTRATION_SUCCESS]: (state: any, action) => ({
            ...state,
            registration: { ...action.payload },
        }),

        [GET_SERVICE_REQUEST_DATA_SUCCESS]: (state, action) => ({
            ...state,
            claims: claimOrderReducer(state.claims, action),
        }),
        [GET_WARRANTY_INFO_DATA_SUCCESS]: (state, action) => ({
            ...state,
            ...warrantyReducer(state.warranties, action),
        }),
        [RESET_DEVICE_DATA]: () => INITIAL_DEVICE_STATE,
        [GET_CLAIM_DETAILS_DATA_SUCCESS]: (state: any, action) => ({
            ...state,
            claimDetails: { ...action },
        }),
        [SHOW_ORDER_UPDATE_ALERT]: (state: any, action) => ({
            ...state,
            showOrderUpdateAlert: true,
        }),
        [HIDE_ORDER_UPDATE_ALERT]: (state: any, action) => ({
            ...state,
            showOrderUpdateAlert: false,
        }),
        [GET_RECONCILE_USERS_SUCCESS]: (state: any, action) => (
        {
            ...state,
            reconcileUsers: action.payload ,
        }),
        [PUT_RECONCILE_SHIPPING_LABEL_SUCCESS]: (state: any, action) => (
        {
            ...state,
            reconcileShippinglabel: {...action.payload},
        }),
        [PUT_RECONCILE_SHIPPING_LABEL_FAILURE]: (state: any, action) => (
        {
            ...state,
            reconcileShippinglabel: {...action.payload},
        }),

    },
    INITIAL_DEVICE_STATE
);
